// extracted by mini-css-extract-plugin
export var avatarContainer = "_gk-0";
export var avatarTypingWave = "_gk-i";
export var gray = "_gk-f";
export var green = "_gk-c";
export var icon = "_gk-9";
export var image = "_gk-1";
export var lg = "_gk-6";
export var md = "_gk-5";
export var presenceDot = "_gk-b";
export var red = "_gk-d";
export var sm = "_gk-4";
export var status = "_gk-a";
export var typingDot = "_gk-h";
export var typingPill = "_gk-g";
export var xl = "_gk-7";
export var xs = "_gk-3";
export var xxl = "_gk-8";
export var xxs = "_gk-2";
export var yellow = "_gk-e";